const pim_host = 'https://nutrisearch.system.net.nz';

export const imagePath = `${pim_host}/product_images/`;
export const thumbnailPath = `${pim_host}/product_thumbnails/`;
export const croppedPath = `${pim_host}/product_cropped/`;
export const docPath = `${pim_host}/product_docs/`;

/**
 * Host-absolute path of the CakePHP backend. It is a directory beside the SPA, so it stays
 * `/backend/` whether the SPA is served from `/` or `/v2/`.
 */
export const backendPath = '/backend/';
